<template>
  <div v-if="visible" class="mask" @click.self="$emit('close')">
    <div class="modal">
      <button class="modal-close" @click="$emit('close')">×</button>
      <h3>登录/注册</h3>
      <input v-model="form.mobile" maxlength="11" placeholder="请输入手机号码" />
      <div class="code-row">
        <input v-model="form.code" maxlength="6" placeholder="请输入验证码" />
        <button class="secondary-btn" @click="sendCode">{{ countdown > 0 ? `${countdown}s` : "发送验证码" }}</button>
      </div>
      <button class="main-btn" @click="submitLogin">登录/注册</button>
    </div>
  </div>
</template>

<script>
import { userApi } from "../api/user";

export default {
  name: "LoginModal",
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      form: { mobile: "", code: "" },
      sending: false,
      countdown: 0,
      timer: null
    };
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async sendCode() {
      if (this.sending || this.countdown > 0) return;
      if (!/^1\d{10}$/.test(this.form.mobile)) {
        window.alert("请输入正确手机号");
        return;
      }
      this.sending = true;
      try {
        const res = await userApi.sendLoginCode({ mobile: this.form.mobile });
        const cd = Number((res && res.cooldown) || 60);
        this.countdown = Number.isFinite(cd) && cd > 0 ? cd : 60;
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            this.countdown = 0;
            if (this.timer) clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        window.alert("验证码已发送，请查收短信");
      } catch (e) {
        window.alert(e && e.message ? e.message : "发送验证码失败");
      } finally {
        this.sending = false;
      }
    },
    submitLogin() {
      if (!/^1\d{10}$/.test(this.form.mobile) || !/^\d{4,6}$/.test(this.form.code)) {
        window.alert("请检查手机号和验证码");
        return;
      }
      this.$emit("submit", { ...this.form });
      this.form = { mobile: "", code: "" };
    }
  }
};
</script>

<style scoped>
.modal {
  position: relative;
}

.modal-close {
    position: absolute;
    right: 14px;
    top: 10px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.06);
    color: #fff;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}
</style>
